export { RENDERER_TYPE, passwordRenderer } from "./passwordRenderer.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/renderers/passwordRenderer/index.mjs
// module id = 576
// module chunks = 1